import { useState, Fragment, type MouseEvent } from "react"
import { map } from "lodash"
import { Popover } from "@mui/material"
import { Info } from "@mui/icons-material"
import "./style.scss"

interface InfoValue {
  label?: string
  value?: string
  className?: string
}

export interface InfoEntry {
  label?: string
  value?: string
  className?: string
  values?: InfoValue[]
}

interface ResourceTooltipInfoProps {
  info: InfoEntry[]
  /** Shown above the entries by the resources list; the header shells pass neither. */
  alias?: string
  label?: string
}

export default function ResourceTooltipInfo({ alias, label, info }: ResourceTooltipInfoProps) {
  const [infoAnchor, setInfoAnchor] = useState<SVGSVGElement | null>(null)

  const openInfo = (e: MouseEvent<SVGSVGElement>) => setInfoAnchor(e.currentTarget)
  const closeInfo = () => setInfoAnchor(null)

  const renderInfo = (item: InfoEntry, i: number) => {
    if (item.values) {
      return <Fragment key={i}>
        <li className="resource-info-label">{item.label}</li>
        {map(item.values, (value, j) =>
          <li key={j} className={value.className}>
            <span className="resource-values-label">{value.label}</span>
            <span className="resource-values-value">{value.value}</span>
          </li>,
        )}
      </Fragment>
    } else if (item.value) {
      return <Fragment key={i}>
        <li className="resource-info-label">{item.label}</li>
        <li className={item.className}>{item.value}</li>
      </Fragment>
    }

    return <li key={i} className="resource-info-label">{item.label}</li>
  }

  return <div className="components_resource-tooltip-info resource-info-wrapper">
    <Info onMouseEnter={openInfo} onMouseLeave={closeInfo} />
    <Popover
      open={!!infoAnchor}
      anchorEl={infoAnchor}
      style={{ pointerEvents: "none" }}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      onClose={closeInfo}
      disableRestoreFocus
    >
      <ul className="resource-info">
        {label && <li>{label}</li>}
        {alias && <>
          <li className="alias-label">Alias</li>
          <li>{alias}</li>
        </>}
        {map(info, renderInfo)}
      </ul>
    </Popover>
  </div>
}
